import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchMeasurementTemplateList = ({commit}) => {

    axios.get('/measurementTemplate/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setMeasurementTemplateList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-1'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchMeasurementTemplateData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/measurementTemplate/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setMeasurementTemplateData', {response: res.data.response, copy: payload.copy})   
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetMeasurementTemplateData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitMeasurementTemplateData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/measurementTemplate/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            router.push(router.currentRoute.fullPath.replace('/form/', ''))
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteMeasurementTemplateData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/measurementTemplate/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchMeasurementTemplateList')
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/measurementTemplate/actions.js